export default __webpack_public_path__ + "static/geetha-a37165851edf8de27f812b9f5539aee7.png";